import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';

import Input from 'common/components/form/inputs/Input';
import Textarea from 'common/components/form/inputs/Textarea';

const Body = ({ formState }) => {
  const { fields, changeField } = useFormState(formState);
  return (
    <div className="ps-9 pe-10">
      <Row className="no-gutters">
        <Col className="pe-2">
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>
        <Col className="d-flex flex-column">
          <span className="fs-10 text-primary fw-bold">LABEL</span>
          <span className="read-only-label">{fields.label.value}</span>
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Textarea
            label="Description"
            onChange={changeField('description')}
            {...fields.description}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Body;
